import { post } from '@/utils/examMan/request'

/**
 * 通用请求类
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postData(url, data) {
  return post(url, data)
}
